import React, { Fragment } from 'react'
import Link from 'gatsby-link'

import { Image } from '../utils/lazyImage'
import HeaderSpacer from '../global/header-spacer'
import Person from './person'
import Navigation from '../navigation'

import globalState from '../../helpers/globalState'
import AstRenderer, { hasASTContent } from '../utils/renderAst'

import Styles from '../../styles/components/page.module.scss'
// import renderAst from '../utils/renderAst'
const { container, featuredMedia, pageSection } = Styles

class TeamPage extends React.PureComponent {
  render() {
    const teampage = this.props.data.teampage
    // console.log('contentAst', teampage.contentAst)
    return (
      <div className={container} style={{ overflow: 'hidden' }}>
        {teampage.acf.show_featured_image &&
        teampage.featured_media &&
        teampage.featured_media.localFile ? (
          <div className={featuredMedia}>
            <Fragment>
              {teampage.acf.show_header_spacer && <HeaderSpacer />}
              <Image
                sizes={teampage.featured_media.localFile.childImageSharp.sizes}
                backgroundColor={
                  teampage.featured_media.localFile.childImageSharp.bgColor
                }
              />
            </Fragment>
          </div>
        ) : (
          <HeaderSpacer />
        )}
        {hasASTContent(teampage.contentAst) && (
          <div className={`styled-content ${pageSection}`}>
            <AstRenderer ast={teampage.contentAst} />
          </div>
        )}
        {teampage.acf.team_tiles_page &&
          teampage.acf.team_tiles_page.map((person, index) => (
            <Person
              name={person.name}
              title={person.title}
              description={person.opisAst}
              main={teampage.acf.team_tiles_page.length === 1}
              image={
                person.respImage
                // person.photo &&
                // person.photo.localFile.childImageSharp &&
                // person.photo.localFile.childImageSharp.sizes
              }
              path={person.path}
            />
          ))}

        {/* <Person
          name="Łukasz Rożański"
          title="Tytuł w firmie"
          description="Kilka słow o sobie Schematy otaczają nas z każdej strony. Z definicji (SJP) schemat to «gotowy wzór czegoś, powielany potem wielokrotnie». Chcemy mieć kontrolę nad podejmowanymi działaniami, bo możemy w ten sposób spodziewać się określonych efektów."
          image={this.props.data.lukasz.childImageSharp.sizes}
        />
        <Person
          name="Łukasz Rożański"
          title="Tytuł w firmie"
          description="Kilka słow o sobie Schematy otaczają nas z każdej strony. Z definicji (SJP) schemat to «gotowy wzór czegoś, powielany potem wielokrotnie». Chcemy mieć kontrolę nad podejmowanymi działaniami, bo możemy w ten sposób spodziewać się określonych efektów."
          image={this.props.data.lukasz.childImageSharp.sizes}
        /> */}
        <Navigation />
      </div>
    )
  }
}

export default TeamPage

// export const pageQuery = graphql`
//   query ONas {
//     featured: file(relativePath: { eq: "nasz-zespol.jpg" }) {
//       childImageSharp {
//         sizes(maxWidth: 1885, traceSVG: { color: "#821749" }) {
//           tracedSVG
//           aspectRatio
//           src
//           srcSet
//         }
//       }
//     }
//     lukasz: file(relativePath: { eq: "lukasz.jpg" }) {
//       childImageSharp {
//         sizes(maxWidth: 1885, traceSVG: { color: "#821749" }) {
//           tracedSVG
//           aspectRatio
//           src
//           srcSet
//         }
//       }
//     }
//   }
// `;



// WEBPACK FOOTER //
// ./src/components/team/team.js